import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {NewBaseResponseInterface} from "@/common/Http/Interfaces/NewBaseResponseInterface";
import {LoginAsOtherUserDataInterface} from "@/api/Auth/LoginAsUser/Interfaces/LoginAsOtherUserDataInterface";
import {LoginAsOtherUserPayloadInterface} from "@/api/Auth/LoginAsUser/Interfaces/LoginAsOtherUserPayloadInterface";

const restApiConfig = new RESTAPIConfig();

export const LoginAsUserApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        loginAsOtherUser: builder.mutation<NewBaseResponseInterface<LoginAsOtherUserDataInterface>, LoginAsOtherUserPayloadInterface>({
            query: (body) => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.loginAsOtherUser(),
                method: "POST",
                body,
            }),
            invalidatesTags: (result, error, arg) => {
                if (result === undefined) {
                    return [];
                }
                return ["CurrentUser", "CurrentUserMenu"];
            }
        })
    })
});

export const {useLoginAsOtherUserMutation} = LoginAsUserApiSlice;
